import SectionMakeDocument from './SectionMakeDocument'

export default SectionMakeDocument
